import React from "react"
import ButtonTemplate from "./ButtonTemplate"

export const widgetSecondaryButtonPrototype = [
    "buttonicons",
    {
        key: "size",
        type: "SELECT",
        label: "Größe",
        size: 6,
        options: [
            {
                value: "medium",
                label: "Normal (100)",
            },
            {
                value: "small",
                label: "Klein (50)",
            },
        ],
    },
]

const SecondaryButtonWidget = ({widget, value, payload, triggerAction}) => {
    const {size = "medium"} = widget
    return (
        <ButtonTemplate
            size={size}
            buttonText={widget.text}
            actionType={widget.action}
            startIcon={widget.startIcon}
            endIcon={widget.endIcon}
            variant={"secondary"}
            payload={payload ?? value}
            triggerAction={triggerAction}
            onClick={widget.onClick}
        />
    )
}

export default SecondaryButtonWidget
